import Movie from './Movie';
import Football from './Football';
import Network from './Network';
import Twitter from './Twitter';
import RussianTroll from './RussianTroll';
import TrumpWorld from './TrumpWorld';
import SpreadSheet from './SpreadSheet';
import Bloom from './Bloom';
import LegisGraph from './LegisGraph';
import PanamaPapers from './PanamaPapers';
import GraphAlgorithms from './GraphAlgorithms';
import BlankSandbox from './BlankSandbox';
import CrimeInvestigation from './CrimeInvestigation';
import Yelp from './Yelp';
import FundamentalTraining from './FundamentalTraining';
import FraudDetection from './FraudDetection';
import ContactTracking from './ContactTracking';
import OpenStreetMapIcon from './OpenStreetMapIcon';
import RecommendationIcon from './RecommendationIcon';
import StackOverflow from './StackOverflow';
import Twitch from './Twitch';
import EntityResolution from './EntityResolution';
import Cybersecurity from './Cybersecurity';
import HealthcareAnalytics from './HealthcareAnalytics';
export default {
    Movie: Movie,
    Football: Football,
    Network: Network,
    Twitter: Twitter,
    RussianTroll: RussianTroll,
    TrumpWorld: TrumpWorld,
    SpreadSheet: SpreadSheet,
    Bloom: Bloom,
    LegisGraph: LegisGraph,
    PanamaPapers: PanamaPapers,
    GraphAlgorithms: GraphAlgorithms,
    BlankSandbox: BlankSandbox,
    CrimeInvestigation: CrimeInvestigation,
    Yelp: Yelp,
    FundamentalTraining: FundamentalTraining,
    FraudDetection: FraudDetection,
    ContactTracking: ContactTracking,
    OpenStreetMapIcon: OpenStreetMapIcon,
    RecommendationIcon: RecommendationIcon,
    StackOverflow: StackOverflow,
    Twitch: Twitch,
    EntityResolution: EntityResolution,
    Cybersecurity: Cybersecurity,
    HealthcareAnalytics: HealthcareAnalytics,
};
